// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/widget-upload-document-request-schema',
  type: 'object',
  required: ['uploadFile', 'id'],
  properties: {
    uploadFile: {
      type: 'object',
    },
    id: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
